import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DynamicModalComponent } from './dynamic-modal/dynamic-modal.component';
import { SyllabusScreenComponent } from './yoklama/ders-programi/syllabus-screen.component';
import { HocaDersProgramiComponent } from './yoklama/hoca-ders-programi/hoca-ders-programi.component';
import { TeacherCourseComponent } from './yoklama/ders-baslat/teacher-course.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterPipe } from 'app/helpers/filter.pipe';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';

import { WelcomeComponent } from './yoklama/welcome/welcome.component';
import { DeviceManagementComponent } from './yoklama/cihaz-yonetimi/device-management.component';
import { DeviceVerificationComponent } from './yoklama/cihaz-yonetimi/cihaz-ekle/device-verification.component';
import { StudentAttendanceComponent } from './yoklama/derse-katil/student-attendance.component';
import { FeedbackComponent } from './yoklama/feedback/feedback.component';
import { KvkkDialogComponent } from './yoklama/kvkk/kvkk-dialog.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    DynamicModalComponent,
    SyllabusScreenComponent,
    HocaDersProgramiComponent,
    TeacherCourseComponent,
    FilterPipe,
    WelcomeComponent,
    DeviceManagementComponent,
    DeviceVerificationComponent,
    StudentAttendanceComponent,
    FeedbackComponent,
    KvkkDialogComponent
  ],

  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    MatRadioModule,
    MatSelectModule,
    MatIconModule,
    MatToolbarModule,
    MatCheckboxModule,

    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    MatGridListModule,
    FormsModule,
    MatExpansionModule,
    MatStepperModule,
    MatSlideToggleModule, // 🔥 Buraya ekledik
    MatListModule,
ReactiveFormsModule,
 MatMenuModule,
MatButtonModule,
MatIconModule

  ],
})
export class AdminComponentsModule {}
